import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AxiosError } from 'axios';

export const getAccountIntegrationConfig = createAsyncThunk(
  'accountIntegrationConfig/getAccountIntegrationConfig',
  async (params: { AccountID: string }, { rejectWithValue }) => {
    console.log('getAccountIntegrationConfig params', params);
    const { AccountID } = params;
    try{
      const response = await api.get(
        `/account/${AccountID.toLowerCase()}/integration_config`, //params,
        { timeout: 30000 }
      );
      console.log('getAccountIntegrationConfig response', response);
      return response.data;
    }catch(e){
      if((e as AxiosError).response){
        rejectWithValue((e as AxiosError).response?.data);
      }
    }
  }
);

const initialState: {
  status: string;
  error: string;
  pending: boolean;
  complete: boolean;
  config: {
    salesforce: boolean;
  };
} = {
  status: '',
  error: '',
  pending: false,
  complete: false,
  config: {
    salesforce: false,
  }, // config
};

const accountIntegrationConfigSlice = createSlice({
  name: 'accountIntegrationConfigSlice',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getAccountIntegrationConfig.pending, (state) => {
      console.log('getAccountIntegrationConfig.pending');
      state.config = {
        salesforce: false,
      };
      state.pending = true;
      state.complete = false;
      state.error = '';
    });

    builder.addCase(getAccountIntegrationConfig.fulfilled, (state, action) => {
      console.log('getAccountIntegrationConfig.fulfilled ', action);
      state.pending = false;
      state.complete = true;
      state.error = '';
      state.config.salesforce = action.payload.salesforce;
    });

    builder.addCase(getAccountIntegrationConfig.rejected, (state, action) => {
      console.log('getAccountIntegrationConfig.rejected action', action);
      console.log(
        'getAccountIntegrationConfig.rejected action payload',
        action.payload
      );
      state.pending = false;
      state.complete = false;
      state.error = action.error ? action.error.message! : '';
    });
  },
});

export default accountIntegrationConfigSlice;
